module.exports = __webpack_public_path__ + "media/images/about-us/Headshots/Dan Allard-adfe032266a311ab8812089671ad4689.jpg";